<div class="associations-container dark-mode">

    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="mb-2 w-100" appearance="outline" >
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
            </div>

        </div>
    </div>


    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Certification Title</th>
                <th class="text-nowrap">Attendance Type</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="certifications.length > 0">
                <tr *ngFor="let cert of certifications">
                    <td class="text-start">
                        {{cert.certificationTitle}}
                    </td>

                    <td class="text-start">
                        {{mergeAttendanceTypes(cert.attendanceTypes)}}
                    </td>
                    <td class="text-center p-1 action-column"  style="width: 160px">
                        <div class="d-flex gap-4 justify-content-center">
                            <mat-icon class="text-white mr-2" (click)="viewCert(cert.id)">arrow_forward</mat-icon>
                        </div>

                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="certifications.length == 0">
                <td colspan="3" class="text-center">
                    <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="certifications.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>
